import { Store } from "@ngxs/store";
import { TealCompEncounter, TealCompEncounterDetails } from "../../../models/encounter";
import { EncounterService } from "../../../services/encounter.service";
import { ClaimService } from "../../../services/claim.service";
import { ReferralService } from "../../../services/referral.service";
import { DraftEmail, DraftEmailInsert, IEmailHandler, EncounterDraftEmail, ReferralDraftEmail, SentEmail, IRecipient, HarloweSupport, EmailService } from "@harlowe/core";

export class EncounterEmailHandler implements IEmailHandler
{
    emailRecipients: Map<string, IRecipient> = new Map();
    attachments: Map<string, HarloweSupport.File[]> = new Map();
    draftType?: number | undefined;

    constructor
    (
        private encounter: TealCompEncounter | TealCompEncounterDetails,
        private _emailService: EmailService,
        private _encounters: EncounterService,
        private _referrals: ReferralService,
        private _claims: ClaimService,
        private _store: Store
    )
    {
    }

    // Create Email Recipient List upon initilization
    async create(draftType?: number): Promise<EncounterEmailHandler>
    {
        this.draftType = draftType;

        // if (draftType == 0 && this.encounter.attachments.length > 0)
        this.attachments.set("Encounter", this.encounter.attachments);
        // if (draftType == 1 && this.encounter.referral && (this.encounter.referral.attachments.length ?? 0) > 0)
        this.attachments.set("Referral", this.encounter.referral.attachments);

        const claim = this.encounter.referral.claim;

        const adjuster = claim?.adjuster;
        this.emailRecipients.set("Adjuster", { 
            firstName: adjuster?.firstName,
            lastName: adjuster?.lastName, 
            fullName: adjuster?.firstName + ' ' + adjuster?.lastName,
            emailAddresses: [adjuster?.emailAddress],
        } as IRecipient);

        if (claim?.adjuster2)
        {
            const adjuster2 = claim?.adjuster2;
            this.emailRecipients.set("Adjuster 2", { 
                firstName: adjuster2.firstName,
                lastName: adjuster2.lastName, 
                fullName: adjuster2.firstName + ' ' + adjuster2.lastName,
                emailAddresses: [adjuster2.emailAddress],
            } as IRecipient);  
        }

        if (claim?.adjusterSupervisor)
        {
            const adjusterSupervisor = claim?.adjusterSupervisor;
            this.emailRecipients.set("Adjuster Supervisor", { 
                firstName: adjusterSupervisor.firstName,
                lastName: adjusterSupervisor.lastName, 
                fullName: adjusterSupervisor.firstName + ' ' + adjusterSupervisor.lastName,
                emailAddresses: [adjusterSupervisor.emailAddress],
            } as IRecipient);
        }

        const party = claim?.party;
        this.emailRecipients.set("Patient", { 
            firstName: party?.firstName,
            lastName: party?.lastName, 
            fullName: party?.firstName + ' ' + party?.lastName,
            emailAddresses: party?.emails.map(e => e.emailAddress),
        } as IRecipient);

        return this;
    }

    async saveDraftEmail(email: DraftEmail): Promise<void> {
        if (email.id != null && email.id != -1)
            await this._emailService.updateDraftEmail(email.id, email);
        else if (this.draftType == 0)
        {
            var encounterDraft = new EncounterDraftEmail(email.recipients, email.subject, email.body, email.from, );
            encounterDraft.encounterId = this.encounter.id;
            await this._encounters.addEncounterDraftEmail(this.encounter.id, encounterDraft);
        }
        else if (this.draftType == 1)
        {
            var referralDraft = new ReferralDraftEmail(email.recipients, email.subject, email.body, email.from);
            referralDraft.referralId = this.encounter.referral.id;
            await this._referrals.addReferralDraftEmail(this.encounter.referral.id, referralDraft);
        }
    }

    async sendEmail(draftEmail: DraftEmail): Promise<SentEmail | undefined>
    {
        if(this.encounter && draftEmail)
        {
            var draftInsert = new DraftEmailInsert
            (
                draftEmail.subject,
                draftEmail.recipients,
                draftEmail.body,
                draftEmail.ccs,
                draftEmail.bccs,
                draftEmail.from,
                draftEmail.attachmentIds
            )
            return await this._encounters.sendNewEmail(this.encounter.id,draftInsert) as SentEmail;
        }
        return;
    }

    updateAttachments(attachmentType: string, files: HarloweSupport.File[]): void
    {
        this.attachments.set(attachmentType, files);
    }

    getRelatedObject(): TealCompEncounter {
        return this.encounter;
    }

}

